<!-- filepath: /Users/minus4/Kod/Bitbucket/new-muzible-www-login/src/views/Subscription.vue -->

<template>
  <div>
    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="subscription-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-email-newsletter</v-icon>
                  <h1 class="header-title">Subscriptions</h1>
                </div>
                <p class="header-subtitle">
                  Manage your newsletter, artist subscriptions and notification preferences
                </p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Info Alert -->
              <v-alert
                type="info"
                variant="outlined"
                class="subscription-info-alert mb-4"
                icon="mdi-information"
              >
                <div class="alert-content">
                  <div class="alert-title">Stay Updated</div>
                  <div class="alert-text">
                    Subscribe to our newsletters to receive updates about new features, releases, and exclusive content
                  </div>
                </div>
              </v-alert>

              <!-- Artist Subscriptions Section -->
              <div class="subscription-section">
                <h2 class="section-title">
                  <v-icon left>mdi-account-music</v-icon>
                  Artist Subscriptions
                </h2>

                <!-- Empty State or Artist Subscriptions List -->
                <div v-if="artistSubscriptions.length === 0" class="subscriptions-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-account-music-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No Artist Subscriptions</h3>
                  <p class="empty-subtitle">
                    You haven't subscribed to any artists yet. Support your favorite artists with monthly subscriptions.
                  </p>
                </div>

                <!-- Sample Artist Subscription (Disabled/Greyed Out) -->
                <div class="artist-subscriptions-list pt-4">
                  <div class="artist-subscription-item sample-item">
                    <div class="artist-subscription-header">
                      <div class="artist-avatar sample-avatar">
                        <v-icon size="40" color="grey">mdi-account-music</v-icon>
                      </div>
                      <div class="artist-info">
                        <h3 class="artist-name sample-text">Sample Artist Name</h3>
                        <p class="artist-meta sample-text">
                          <v-icon size="14" class="meta-icon">mdi-calendar</v-icon>
                          Subscribed since: January 2024
                        </p>
                      </div>
                      <div class="subscription-badge sample-badge">
                        <v-chip size="small" color="grey" variant="outlined">
                          <v-icon left size="14">mdi-crown</v-icon>
                          Premium
                        </v-chip>
                      </div>
                    </div>

                    <div class="artist-subscription-body">
                      <div class="subscription-details">
                        <div class="detail-item">
                          <v-icon size="20" color="grey">mdi-cash</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Monthly Amount</span>
                            <span class="detail-value sample-text">$9.99 / month</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="grey">mdi-calendar-refresh</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Next Payment</span>
                            <span class="detail-value sample-text">December 15, 2024</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="grey">mdi-credit-card</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Payment Method</span>
                            <span class="detail-value sample-text">Visa •••• 4242</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="grey">mdi-chart-line</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Total Contributed</span>
                            <span class="detail-value sample-text">$119.88</span>
                          </div>
                        </div>
                      </div>

                      <div class="subscription-benefits">
                        <h4 class="benefits-title sample-text">Subscription Benefits</h4>
                        <div class="benefits-list">
                          <div class="benefit-item sample-text">
                            <v-icon size="16" color="grey">mdi-check-circle</v-icon>
                            <span>Early access to new releases</span>
                          </div>
                          <div class="benefit-item sample-text">
                            <v-icon size="16" color="grey">mdi-check-circle</v-icon>
                            <span>Exclusive behind-the-scenes content</span>
                          </div>
                          <div class="benefit-item sample-text">
                            <v-icon size="16" color="grey">mdi-check-circle</v-icon>
                            <span>Direct support to artist</span>
                          </div>
                          <div class="benefit-item sample-text">
                            <v-icon size="16" color="grey">mdi-check-circle</v-icon>
                            <span>Priority customer support</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="artist-subscription-footer">
                      <v-btn
                        variant="outlined"
                        color="grey"
                        prepend-icon="mdi-eye"
                        disabled
                        class="sample-button"
                      >
                        View Profile
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        color="grey"
                        prepend-icon="mdi-cancel"
                        disabled
                        class="sample-button"
                      >
                        Cancel Subscription
                      </v-btn>
                    </div>

                    <div class="sample-overlay">
                      <div class="sample-label">
                        <v-icon left size="20">mdi-information</v-icon>
                        Sample Preview
                      </div>
                    </div>
                  </div>

                  <!-- Real Artist Subscriptions (from API) -->
                  <div 
                    v-for="artist in artistSubscriptions" 
                    :key="artist.id"
                    class="artist-subscription-item"
                  >
                    <div class="artist-subscription-header">
                      <div class="artist-avatar">
                        <img v-if="artist.avatar" :src="artist.avatar" :alt="artist.name" />
                        <v-icon v-else size="40" color="white">mdi-account-music</v-icon>
                      </div>
                      <div class="artist-info">
                        <h3 class="artist-name">{{ artist.name }}</h3>
                        <p class="artist-meta">
                          <v-icon size="14" class="meta-icon">mdi-calendar</v-icon>
                          Subscribed since: {{ formatDate(artist.subscribedDate) }}
                        </p>
                      </div>
                      <div class="subscription-badge">
                        <v-chip size="small" color="primary" variant="outlined">
                          <v-icon left size="14">mdi-crown</v-icon>
                          {{ artist.tier }}
                        </v-chip>
                      </div>
                    </div>

                    <div class="artist-subscription-body">
                      <div class="subscription-details">
                        <div class="detail-item">
                          <v-icon size="20" color="primary">mdi-cash</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Monthly Amount</span>
                            <span class="detail-value">${{ artist.monthlyAmount }} / month</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="primary">mdi-calendar-refresh</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Next Payment</span>
                            <span class="detail-value">{{ formatDate(artist.nextPayment) }}</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="primary">mdi-credit-card</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Payment Method</span>
                            <span class="detail-value">{{ artist.paymentMethod }}</span>
                          </div>
                        </div>

                        <div class="detail-item">
                          <v-icon size="20" color="success">mdi-chart-line</v-icon>
                          <div class="detail-content">
                            <span class="detail-label">Total Contributed</span>
                            <span class="detail-value">${{ artist.totalContributed }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="subscription-benefits">
                        <h4 class="benefits-title">Subscription Benefits</h4>
                        <div class="benefits-list">
                          <div 
                            v-for="(benefit, index) in artist.benefits" 
                            :key="index"
                            class="benefit-item"
                          >
                            <v-icon size="16" color="success">mdi-check-circle</v-icon>
                            <span>{{ benefit }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="artist-subscription-footer">
                      <v-btn
                        variant="outlined"
                        color="white"
                        prepend-icon="mdi-eye"
                        @click="viewArtistProfile(artist.id)"
                      >
                        View Profile
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        color="error"
                        prepend-icon="mdi-cancel"
                        @click="cancelArtistSubscription(artist.id)"
                      >
                        Cancel Subscription
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Active Subscriptions Section -->
              <div class="subscription-section">
                <h2 class="section-title">
                  <v-icon left>mdi-email-check</v-icon>
                  Newsletter Subscriptions
                </h2>

                <!-- Empty State or Subscription List -->
                <div v-if="subscriptions.length === 0" class="subscriptions-empty-state">
                  <div class="empty-icon-wrapper">
                    <v-icon size="64" color="grey">mdi-email-off-outline</v-icon>
                  </div>
                  <h3 class="empty-title">No Active Subscriptions</h3>
                  <p class="empty-subtitle">
                    You haven't subscribed to any newsletters yet. Browse available subscriptions below.
                  </p>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Available Subscriptions Section -->
              <div class="subscription-section">
                <h2 class="section-title">
                  <v-icon left>mdi-email-plus</v-icon>
                  Available Subscriptions
                </h2>

                <div class="available-subscriptions-grid">
                  <!-- Newsletter Card -->
                  <div class="subscription-card newsletter-card">
                    <div class="card-header">
                      <div class="card-icon-wrapper newsletter-icon">
                        <v-icon size="32">mdi-newspaper-variant</v-icon>
                      </div>
                      <div class="card-badge">
                        <v-chip size="small" color="primary">Popular</v-chip>
                      </div>
                    </div>
                    <div class="card-content">
                      <h3 class="card-title">Weekly Newsletter</h3>
                      <p class="card-description">
                        Get weekly updates about new music releases, featured artists, and platform updates
                      </p>
                      <div class="card-features">
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>New Releases</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Artist Spotlights</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Platform News</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <v-btn
                        variant="outlined"
                        color="white"
                        block
                        prepend-icon="mdi-email-plus"
                        @click="subscribe('newsletter')"
                      >
                        Subscribe
                      </v-btn>
                    </div>
                  </div>

                  <!-- Updates Card -->
                  <div class="subscription-card updates-card">
                    <div class="card-header">
                      <div class="card-icon-wrapper updates-icon">
                        <v-icon size="32">mdi-bell-ring</v-icon>
                      </div>
                    </div>
                    <div class="card-content">
                      <h3 class="card-title">Product Updates</h3>
                      <p class="card-description">
                        Stay informed about new features, improvements, and important announcements
                      </p>
                      <div class="card-features">
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Feature Updates</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>System News</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Maintenance Alerts</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <v-btn
                        variant="outlined"
                        color="white"
                        block
                        prepend-icon="mdi-email-plus"
                        @click="subscribe('updates')"
                      >
                        Subscribe
                      </v-btn>
                    </div>
                  </div>

                  <!-- Events Card -->
                  <div class="subscription-card events-card">
                    <div class="card-header">
                      <div class="card-icon-wrapper events-icon">
                        <v-icon size="32">mdi-calendar-star</v-icon>
                      </div>
                    </div>
                    <div class="card-content">
                      <h3 class="card-title">Events & Concerts</h3>
                      <p class="card-description">
                        Receive notifications about upcoming events, concerts, and special performances
                      </p>
                      <div class="card-features">
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Event Announcements</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Ticket Sales</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="16" color="success">mdi-check-circle</v-icon>
                          <span>Exclusive Offers</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                      <v-btn
                        variant="outlined"
                        color="white"
                        block
                        prepend-icon="mdi-email-plus"
                        @click="subscribe('events')"
                      >
                        Subscribe
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Preferences Section -->
              <div class="subscription-section">
                <h2 class="section-title">
                  <v-icon left>mdi-tune</v-icon>
                  Notification Preferences
                </h2>

                <div class="preferences-card">
                  <div class="preference-item">
                    <div class="preference-info">
                      <v-icon class="preference-icon">mdi-email</v-icon>
                      <div class="preference-text">
                        <h4 class="preference-title">Email Notifications</h4>
                        <p class="preference-desc">Receive updates via email</p>
                      </div>
                    </div>
                    <v-switch
                      color="white"
                      hide-details
                      :model-value="true"
                      disabled
                    ></v-switch>
                  </div>

                  <v-divider style="opacity: 0.2;"></v-divider>

                  <div class="preference-item">
                    <div class="preference-info">
                      <v-icon class="preference-icon">mdi-bell</v-icon>
                      <div class="preference-text">
                        <h4 class="preference-title">Push Notifications</h4>
                        <p class="preference-desc">Get instant notifications in browser</p>
                      </div>
                    </div>
                    <v-switch
                      color="white"
                      hide-details
                      :model-value="false"
                      disabled
                    ></v-switch>
                  </div>

                  <v-divider style="opacity: 0.2;"></v-divider>

                  <div class="preference-item">
                    <div class="preference-info">
                      <v-icon class="preference-icon">mdi-cellphone</v-icon>
                      <div class="preference-text">
                        <h4 class="preference-title">SMS Notifications</h4>
                        <p class="preference-desc">Receive important alerts via SMS</p>
                      </div>
                    </div>
                    <v-switch
                      color="white"
                      hide-details
                      :model-value="false"
                      disabled
                    ></v-switch>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:170px!important' : 'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Subscription',

  components: {

  },
  data: () => ({
    navbar: false,
    user: null,
    subscriptions: [],
    artistSubscriptions: [], // Will be populated from API

  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },

  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.$store.dispatch('getSubscriptions', { token: this.user.token
      }).then(response => {
        this.subscriptions = this.$store.getters.getSubscriptions;

      }).catch(error => {
        if (!error.response) {
          this.notifyError(
            "Network problem, please try again later.."
          );
        }
      })

      // TODO: Load artist subscriptions from API
      // this.loadArtistSubscriptions();
    }
  },
  methods: {
    subscribe(type) {
      this.notify(`Subscription to ${type} coming soon!`);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    },
    viewArtistProfile(artistId) {
      this.notify('View Artist Profile feature coming soon!');
    },
    cancelArtistSubscription(artistId) {
      // TODO: Implement cancellation logic
      this.notifyError('Cancellation feature coming soon!');
    },
    loadArtistSubscriptions() {
      // TODO: API call to load artist subscriptions
      // this.$store.dispatch('getArtistSubscriptions', { 
      //   userId: this.user.id, 
      //   token: this.user.token 
      // }).then(response => {
      //   this.artistSubscriptions = response.data;
      // });
    },
    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Subscription Header */
.subscription-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;
}

/* Info Alert */
.subscription-info-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.4) !important;
  border-radius: 12px !important;
  padding: 16px !important;

  :deep(.v-alert__content) {
    color: white !important;
  }
}

.alert-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
}

.alert-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

/* Section */
.subscription-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Empty State */
.subscriptions-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
}

.empty-icon-wrapper {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.empty-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 400px;
  line-height: 1.5;
}

/* Artist Subscriptions List */
.artist-subscriptions-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Artist Subscription Item */
.artist-subscription-item {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
}

.artist-subscription-item:hover {
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* Sample Item Styles */
.artist-subscription-item.sample-item {
  opacity: 0.6;
  pointer-events: none;
  position: relative;
}

.sample-overlay {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.sample-label {
  background: rgba(158, 158, 158, 0.2);
  border: 1px solid rgba(158, 158, 158, 0.4);
  border-radius: 20px;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
}

.sample-text {
  color: rgba(255, 255, 255, 0.5) !important;
}

.sample-avatar {
  opacity: 0.5;
}

.sample-badge :deep(.v-chip) {
  opacity: 0.6;
}

.sample-button {
  opacity: 0.5;
}

/* Artist Subscription Header */
.artist-subscription-header {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.artist-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.2), rgba(33, 150, 243, 0.4));
  border: 2px solid rgba(33, 150, 243, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.artist-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.artist-info {
  flex: 1;
  min-width: 0;
}

.artist-name {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0 0 8px 0;
}

.artist-meta {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.meta-icon {
  opacity: 0.7;
}

.subscription-badge {
  flex-shrink: 0;
}

/* Artist Subscription Body */
.artist-subscription-body {
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 768px) {
  .artist-subscription-body {
    grid-template-columns: 1fr;
  }
}

.subscription-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  transition: background 0.3s ease;
}

.detail-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.detail-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.detail-value {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.subscription-benefits {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.benefits-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0 0 8px 0;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  padding: 8px;
  background: rgba(76, 175, 80, 0.05);
  border-radius: 6px;
  transition: all 0.3s ease;
}

.benefit-item:hover {
  background: rgba(76, 175, 80, 0.1);
  transform: translateX(4px);
}

/* Artist Subscription Footer */
.artist-subscription-footer {
  padding: 16px 24px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

@media (max-width: 480px) {
  .artist-subscription-footer {
    flex-direction: column;
  }
}

.artist-subscription-footer .v-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

/* Available Subscriptions Grid */
.available-subscriptions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

@media (max-width: 768px) {
  .available-subscriptions-grid {
    grid-template-columns: 1fr;
  }
}

/* Subscription Card */
.subscription-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.subscription-card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.card-header {
  padding: 24px 24px 16px;
  position: relative;
}

.card-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.newsletter-icon {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.2), rgba(33, 150, 243, 0.4));
  border: 1px solid rgba(33, 150, 243, 0.3);
}

.updates-icon {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.4));
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.events-icon {
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 152, 0, 0.4));
  border: 1px solid rgba(255, 152, 0, 0.3);
}

.card-badge {
  position: absolute;
  top: 24px;
  right: 24px;
}

.card-content {
  padding: 0 24px 24px;
  flex: 1;
}

.card-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
}

.card-description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 20px;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.card-footer {
  padding: 0 24px 24px;
}

.card-footer .v-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.card-footer .v-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Preferences Card */
.preferences-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px;
  transition: all 0.3s ease;
}

.preferences-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.preference-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px;
  transition: background 0.3s ease;
  border-radius: 8px;
}

.preference-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.preference-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.preference-icon {
  font-size: 24px !important;
  color: rgba(255, 255, 255, 0.7);
}

.preference-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.preference-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.preference-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.subscription-info-alert,
.subscriptions-empty-state,
.subscription-card,
.preferences-card,
.artist-subscription-item {
  animation: slideIn 0.4s ease forwards;
}

.subscription-card:nth-child(1) { animation-delay: 0s; }
.subscription-card:nth-child(2) { animation-delay: 0.05s; }
.subscription-card:nth-child(3) { animation-delay: 0.1s; }

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-chip) {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
}

:deep(.v-switch) {
  flex: 0 0 auto;
}

:deep(.v-switch .v-selection-control__input) {
  width: 48px;
}
</style>